var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-alert",class:{
    visible: !!_vm.toastMsg,
  }},[_c('div',{staticClass:"alert alert-secondary",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.toastMsg)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }